import React, { useState } from 'react';
import { EngagementForm } from '../components/Engagement/EngagementForm';
import { IntentConfirmation } from '../components/Engagement/IntentConfirmation';
import { CommunityAccess } from '../components/Engagement/CommunityAccess';
export const HowToEngage = () => {
  const [currentStep, setCurrentStep] = useState<'form' | 'intent' | 'community'>('form');
  const [formData, setFormData] = useState({});
  const handleFormSubmit = data => {
    setFormData(data);
    setCurrentStep('intent');
  };
  const handleIntentConfirm = (understood: boolean) => {
    if (understood) {
      setCurrentStep('community');
    } else {
      // If they need more details, we could handle that differently
      // For now, just proceed to community access
      setCurrentStep('community');
    }
  };
  return <div className="pt-20 bg-white min-h-screen" data-id="element-3384">
      <section className="relative py-16 border-b border-gray-200" data-id="element-3385">
        <div className="absolute inset-0 z-0" data-id="element-3386">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/veE5AXEU4CEztbBqZpUQcx/coverrs.png" alt="The Networking Salon" className="w-full h-full object-cover grayscale" data-id="element-3387" />
          <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-3388"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-3389">
          <div className="max-w-3xl mx-auto text-center" data-id="element-3390">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-3391">
              Join The Salon
            </h1>
            <p className="text-xl text-gray-200 mb-8" data-id="element-3392">
              Join our community and connect with like-minded professionals
            </p>
          </div>
        </div>
      </section>
      <section className="py-16" data-id="element-3393">
        <div className="container mx-auto px-4" data-id="element-3394">
          <div className="max-w-3xl mx-auto" data-id="element-3395">
            {currentStep === 'form' && <EngagementForm onFormSubmit={handleFormSubmit} data-id="element-3396" />}
            {currentStep === 'intent' && <IntentConfirmation onConfirm={handleIntentConfirm} data-id="element-3397" />}
            {currentStep === 'community' && <CommunityAccess userLocation={formData.location || ''} data-id="element-3398" />}
          </div>
        </div>
      </section>
    </div>;
};